<template>
  <div>
    <canvas-animation/>

    <div id="canvas-overlay">
      <h1 id="blurb">
        {{ blurbs[currentBlurbIndex] }}
      </h1>
    </div>
  </div>
</template>

<script>
import CanvasAnimation from '@/components/CanvasAnimation';

export default {
  components: {
    CanvasAnimation
  },
  props: {
    blurbSpeedMs: {
      default: 4000,
      type: Number
    },
    blurbs: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      currentBlurbIndex: 0,
      updateBlurbInterval: null
    };
  },
  created() {
    // Update the blurb at random every blurbSpeedMs ms
    this.updateBlurbInterval = setInterval(() => {
      let nextIndex = this.currentBlurbIndex;
      while (nextIndex === this.currentBlurbIndex) {
        nextIndex = Math.floor(Math.random() * this.blurbs.length);
      }
      this.currentBlurbIndex = nextIndex;
    }, this.blurbSpeedMs);
  },
  destroyed() {
    clearInterval(this.updateBlurbInterval);
  }
};
</script>

<style lang="scss">
  #blurb {
    @media (min-width: 1922px) {
      font-size: 4.5rem;
    }

    color: #fff;
    /* stylelint-disable-next-line unit-blacklist */
    font: bold calc(2.1rem + 2vw) / 1.4em 'Work Sans', 'Arial', 'Helvetica', sans-serif;
    text-align: center;
    text-shadow: 0 0 30px #110a1a;
    // Use provided whitespace (new lines) but still break if needed
    white-space: pre-wrap;
  }

  #canvas-overlay {
    align-items: center;
    box-shadow: 0 0 1rem #000 inset;
    display: flex;
    height: 54vh;
    justify-content: center;
    max-width: 1920px;
    position: absolute;
    top: $header-height;
    width: 100%;
    z-index: 0;
  }
</style>
